"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_CONFLICT_SOURCE_CHIPS = exports.conflictHeaderUsesDarkText = exports.getConflictSignificanceColor = exports.getConflictSeverityColor = exports.CONFLICT_SIGNIFICANCE_COLORS = exports.CONFLICT_SEVERITY_COLORS = void 0;
exports.CONFLICT_SEVERITY_COLORS = {
    High: { start: '#DC2626', end: '#FCA5A5' },
    Medium: { start: '#FFA500', end: '#FDE047' },
    Low: { start: '#008000', end: '#4ADE80' },
};
exports.CONFLICT_SIGNIFICANCE_COLORS = {
    High: '#F5DADD',
    Medium: '#F8DDAC',
    Low: '#C3EAC3',
};
const toSeverity = (severity) => severity === 'High' || severity === 'Low' ? severity : 'Medium';
/** Gradient stops for the conflict header band. */
const getConflictSeverityColor = (severity) => exports.CONFLICT_SEVERITY_COLORS[toSeverity(severity)];
exports.getConflictSeverityColor = getConflictSeverityColor;
/**
 * Tint behind the "Significance" text. Keyed on severity, like the website:
 * `significance` itself is free prose, not a level.
 */
const getConflictSignificanceColor = (severity) => exports.CONFLICT_SIGNIFICANCE_COLORS[toSeverity(severity)];
exports.getConflictSignificanceColor = getConflictSignificanceColor;
/** Medium severity paints an amber band, which needs dark text. */
const conflictHeaderUsesDarkText = (severity) => toSeverity(severity) === 'Medium';
exports.conflictHeaderUsesDarkText = conflictHeaderUsesDarkText;
/** How many of a conflict's sources the card shows as chips. */
exports.MAX_CONFLICT_SOURCE_CHIPS = 4;
